module.exports = {"errorLogin":"Não esqueça do número do seu documento ou e-mail.","labelLogin":"cpf/cnpj ou e-mail","send":"Enviar"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/ForgotPasswordForm/data.json
// module id = 2121
// module chunks = 0